import init from "../../shared/utils/init"

init(() => {
  const onInit = () => {
    const els = document.querySelectorAll(`.flash-message`)

    const removeFlash = (el) => {
      el.classList.remove(`--active`)

      setTimeout(() => {
        el.remove()
      }, 200)
    }

    Array.prototype.forEach.call(els, (el) => {
      setTimeout(() => {
        el.classList.add(`--active`)
      }, 50)

      el.addEventListener(`click`, () => removeFlash(el))

      const onOutsideClick = (event) => {
        if (!el.contains(event.target)) {
          document.removeEventListener(`click`, onOutsideClick)
          removeFlash(el)
        }
      }
      setTimeout(() => {
        document.addEventListener(`click`, onOutsideClick)
      }, 0)

      if (el.classList.contains(`flash-message--notice`)) {
        setTimeout(() => {
          removeFlash(el)
        }, 7000)
      }
    })
  }

  onInit()

  window.addEventListener(`toast:added`, onInit)
})
